import { Link } from "@/lib/router-compat";

export const INSURANCE_LINKS: Record<string, string> = {
  Aetna: "/insurance/aetna-rehab-nj",
  Anthem: "/insurance/anthem-rehab-nj",
  "Blue Cross Blue Shield": "/insurance/blue-cross-blue-shield-rehab-nj",
  BCBS: "/insurance/blue-cross-blue-shield-rehab-nj",
  Cigna: "/insurance/cigna-rehab-nj",
  "United Healthcare": "/insurance/united-healthcare-rehab-nj",
  UnitedHealthcare: "/insurance/united-healthcare-rehab-nj",
  UMR: "/insurance/united-healthcare-rehab-nj",
  Optum: "/insurance/optum-rehab-nj",
  Carelon: "/insurance/carelon-rehab-nj",
  "Harvard Pilgrim": "/insurance/harvard-pilgrim-rehab-nj",
  Beacon: "/insurance/carelon-rehab-nj",
};

export const DEFAULT_INSURERS = [
  "Aetna",
  "Anthem",
  "Blue Cross Blue Shield",
  "Cigna",
  "United Healthcare",
  "Humana",
  "Magellan",
  "Beacon",
  "Compsych",
  "Health Net",
  "Independence Administrators",
  "Carefirst",
  "& More",
];

interface InsurancePillsProps {
  insurers?: string[];
  className?: string;
  style?: React.CSSProperties;
  linkable?: boolean;
}

const baseStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  background: "#FFFFFF",
  border: "1px solid #F0E0E0",
  borderRadius: 50,
  padding: "8px 16px",
  color: "#8B1A1A",
  fontWeight: 700,
  fontSize: 14,
  lineHeight: 1.2,
};

export const InsurancePill = ({
  children,
  href,
}: {
  children: React.ReactNode;
  href?: string | undefined;
}) => {
  if (href) {
    return (
      <Link to={href} style={{ ...baseStyle, textDecoration: "none" }} className="hover:bg-[#FAF4F0] transition-colors focus:outline-hidden focus:ring-2 focus:ring-secondary">
        {children}
      </Link>
    );
  }
  return <span style={baseStyle}>{children}</span>;
};

const InsurancePills = ({
  insurers = DEFAULT_INSURERS,
  className = "flex flex-wrap gap-2",
  style,
  linkable = true,
}: InsurancePillsProps) => (
  <div className={className} style={style}>
    {insurers.map((name) => {
      const href = linkable ? INSURANCE_LINKS[name] : undefined;
      return (
        <InsurancePill key={name} href={href}>
          {name}
        </InsurancePill>
      );
    })}
  </div>
);

export default InsurancePills;
